<!-- 来电记录 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('热线人员名称')">
              <a-input :placeholder="$t('请输入热线人员名称')" v-model="queryParam.hotlineStaffName"></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item label="系统登录账号">
              <a-select v-model="queryParam.sysUserName" placeholder="请选择系统登录账号">
                <a-select-option v-for="item in candidateUsersList" :value="item.username" :key="item.username">{{item.username}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('是否回访')">
              <a-select v-model="queryParam.isCallback" :placeholder="$t('请选择是否回访')">
                <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                <a-select-option :value="0">{{ $t('否') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('回访时间')">
              <a-range-picker v-model="callbackTime" valueFormat="YYYY-MM-DD" @change="onChange" />
            </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="devicePicture" slot-scope="text,record">
          <div style="width: 30px;height: 30px;cursor: pointer;" @click="viewPicture(text)" v-if="text">
            <img :src="setSrc(text)" alt="" style="width: 100%;height: 100%;"/>
          </div>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>


        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a @click="handleFollowUp(record)">{{ $t('回访') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <Modal ref="modalForm" @ok="loadData"></Modal>
    <j-modal :title="$t('预览')" :width="348" :visible="visiblePirture" :maskClosable="false" @cancel="imghandleCancel" :okButtonProps="{ class:{'jee-hidden': true} }">
      <img :src="viewUrl" alt="" style="width: 300px;height: 300px;"/>
    </j-modal>
  </a-card>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import Modal from './modal'

  export default {
    name: 'CallHistoryIndex',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal,
      JInput
    },
    data () {
      return {
        description: '来电管理页面',
        url: {
          list: "/jeecg-hotline/caller/callerHistory/list",
          delete: "/jeecg-hotline/caller/callerHistory/delete",
          deleteBatch: "/jeecg-hotline/caller/callerHistory/deleteBatch",
          userList: "/sys/user/list",
        },
        queryParam: {},
        visiblePirture: false,
        viewUrl: '',
        candidateUsersList: [],
        callbackTime: []
      }
    },
    created() {},
    mounted(){
      this.getUserList();
      this.loadData();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户水表编号'),
            align:"center",
            dataIndex: 'userMeterId',
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('用户手机号'),
            align:"center",
            dataIndex: 'userPhone',
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('来电人员名称'),
            align:"center",
            dataIndex: 'callerName',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('咨询类型'),
            align:"center",
            dataIndex: 'consultType',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('营收类')
              }else if(t == 1){
                return this.$t('工单类')
              }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('热线人员名称'),
            dataIndex: 'hotlineStaffName',
            align:"center",
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('是否回访'),
            align:"center",
            dataIndex: 'isCallback',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('否')
              }else if(t == 1){
                return this.$t('是')
              }
            },
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('来电时间'),
            align:"center",
            dataIndex: 'callerTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('回访时间'),
            align:"center",
            dataIndex: 'callbackTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('用户满意度'),
            align:"center",
            dataIndex: 'satisfaction',
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      onChange(e){
        if(e.length>0){
          this.queryParam.startTime = e[0];
          this.queryParam.endTime = e[1];
        }else{
          delete this.queryParam.startTime;
          delete this.queryParam.endTime;
        }
      },
      getUserList(){
        getAction(this.url.userList,{status:1,pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      searchReset(){
        this.queryParam = {};
        this.callbackTime = [];
        this.loadData();
      },
      handleAdd(){
        this.$nextTick(()=>{
          this.$refs.modalForm.init({},'add');
        })
      },
      handleEdit(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'edit');
        })
      },
      handleFollowUp(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'follow');
        })
      },
      // 详情
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'detail');
        })
      },
      setSrc(url){
        if(url){
          return window._CONFIG['domianURL']+'/sys/common/static/'+url;
        }
      },
      // 预览图片
      viewPicture(url){
        this.visiblePirture = true;
        this.viewUrl = window._CONFIG['domianURL']+'/sys/common/static/'+url;
      },
      imghandleCancel(){
        this.visiblePirture = false;
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>